import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9c3cdf2c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "line"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "70",
  viewBox: "0 0 23 70",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M0.999973 -9.61652e-07L0.999941 743C0.999941 747.418 4.58166 751 8.99994 751L23 751",
  stroke: "#A666FF"
})], -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  class: "icon"
};
const _hoisted_5 = {
  class: "text-content"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "meta"
};
const _hoisted_8 = {
  class: "product-sku-asin-text"
};
const _hoisted_9 = {
  key: 0,
  style: {
    "position": "relative"
  },
  class: "ellipsis-2"
};
const _hoisted_10 = {
  key: 1,
  class: "sku-not-found"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1));
const _hoisted_12 = {
  style: {
    "position": "relative"
  },
  class: "ellipsis-2"
};
const _hoisted_13 = {
  class: "variation-theme-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chevron_right_icon = _resolveComponent("chevron-right-icon");
  const _component_chevron_down_icon = _resolveComponent("chevron-down-icon");
  const _component_b_img = _resolveComponent("b-img");
  const _component_image_overlayer = _resolveComponent("image-overlayer");
  const _component_product_with_flag_overlay = _resolveComponent("product-with-flag-overlay");
  const _component_WrapWithCopy = _resolveComponent("WrapWithCopy");
  const _component_seo_parent_variation_theme = _resolveComponent("seo-parent-variation-theme");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(), _createBlock(_component_b_td, {
    id: "name-column",
    class: "b-table-sticky-column table-b-table-default custom-td border-table-row col"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["seo-parent-product-cell", {
        'seo-parent-td': !$props.collapsed
      }])
    }, [!$props.collapsed ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [$props.collapsed ? (_openBlock(), _createBlock(_component_chevron_right_icon, {
      key: 0,
      width: 20,
      height: 20
    })) : (_openBlock(), _createBlock(_component_chevron_down_icon, {
      key: 1,
      width: 20,
      height: 20
    }))]), _createVNode(_component_product_with_flag_overlay, {
      flag: $props.parent.flag,
      country: $props.parent.country,
      childrenCount: $props.parent.child_asins_array?.length
    }, {
      default: _withCtx(() => [_createVNode(_component_image_overlayer, {
        overlays: 4
      }, {
        default: _withCtx(() => [_createVNode(_component_b_img, {
          lazy: "",
          src: $props.parent.standardized_main_image_link ?? '/assets/images/amazon-logo-transparent.svg',
          class: "custom-img",
          height: "22.5",
          width: "22.5"
        }, null, 8, ["src"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["flag", "country", "childrenCount"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString($props.parent.standardized_product_name), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [$props.parent.sku ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_WrapWithCopy, null, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.parent.sku), 1)]),
      _: 1
    })])) : (_openBlock(), _createElementBlock("div", _hoisted_10, "SKU not found")), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_WrapWithCopy, null, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.parent.parent_asin), 1)]),
      _: 1
    })])])]), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.parent.parent_variation_theme, theme => {
      return _openBlock(), _createBlock(_component_seo_parent_variation_theme, {
        theme: theme,
        showIcon: true
      }, null, 8, ["theme"]);
    }), 256))])])], 2)]),
    _: 1
  });
}